/*eslint-disable*/
import React from 'react';
import { Redirect } from 'react-router';
import { Query, graphql } from 'react-apollo';
import store from 'store';
import './Results.css';
import gql from 'graphql-tag';
import { ApolloConsumer } from 'react-apollo';

import {
	Table,
	TableHead,
	TableBody,
	TableCell,
	TableRow,
	Card,
	CardContent,
	Paper,
	LinearProgress,
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Typography,
	CircularProgress,
	Grid,
	ListItem,
	List,
	Popover,
	Divider
} from '@material-ui/core';

import { Info } from '@material-ui/icons';
import { Logout, GetUserToken, GetUserId } from 'helpers/UserHelper';

import {
	QuotePdfUri,
	ResultsPdfUri,
	ResultsPdfPhysicalPath
} from 'constants.js';
import { QuoteByGuid } from 'queries/quotesByBroker';
import { showSnack, successWarning } from 'reducers/NotificationReducer';
import { SaveQuote } from 'queries/quotes/mutations/SaveQuote';
import { ParseUriParams } from 'helpers/UriReader';

export const reqResult = gql`
	query getResults($guid: String!, $token: String!) {
		Results(guid: $guid, token: $token) {
			id
			token
		}
	}
`;

const getResultPdf = gql`
	query result($path: String!, $content: String!) {
		ResultPdf(path: $path, content: $content) {
			filename
		}
	}
`;

class Results extends React.Component {
	state = {
		resultsSet: false,
		popoverText: '',
		dialogTitle: '',
		dialogOpen: false,
		loadingPdf: false,
		downloadEl: null,
		anchorTop: 0,
		anchorLeft: 0,
		popoverOpen: false,
		guid: null
	};

	componentDidMount() {
		const params = ParseUriParams(this.props.location.search);
		const { guid } = params;
		this.setState({ guid: guid });
	}

	saveQuote = quote => {
		const input = {
			taskGuid: quote.sq_taskguid,
			client_id: quote.fk_clientID,
			description: quote.desc,
			token: GetUserToken()
		};

		this.props
			.mutate({
				variables: {
					input
				}
			})
			.then(resp => {
				store.dispatch(
					successWarning({
						open: true,
						title: 'Quote Saved!'
					})
				);
			})
			.catch(error => {
				store.dispatch(
					showSnack({
						message: 'An Error has occured.',
						color: 'danger'
					})
				);
			});
	};

	targeter() {
		var res = this.state.results;
		var col = [];

		if (this.state.results) {
			res.targets.forEach(element => {
				var logo = '/assets/logo/' + element + '.png';
				col.push(
					<TableCell className="centerCell" key={element}>
						<img
							src={logo}
							alt={element + 'logo'}
							style={{ maxWidth: '150px', maxHeight: '60px' }}
						/>
					</TableCell>
				);
			});
		}

		return col;
	}

	fitter() {
		var col = [];
		var res = this.state.results;
		res.benefits.forEach(benelement => {
			col.push(
				<TableRow key={benelement}>{this.benefitter(benelement)}</TableRow>
			);
		});

		return col;
	}

	benefitter(benelement) {
		var col = [];
		var res = this.state.results;
		var benefitName = benelement.name;
		var descriptiveName = benelement.descriptiveName;

		descriptiveName && descriptiveName !== ''
			? col.push(
					<TableCell style={{ width: '275px' }} key={benefitName}>
						<Typography gutterBottom>{descriptiveName}</Typography>
					</TableCell>
			  )
			: col.push(
					<TableCell style={{ width: '275px' }} key={benefitName}>
						<Typography gutterBottom>{benefitName}</Typography>
					</TableCell>
			  );

		col.push(
			<TableCell className="centerCell" key={res}>
				R{benelement.amount}
			</TableCell>
		);

		res.targets.forEach(element => {
			col.push(
				<TableCell className="centerCell" key={element}>
					<div className="description">
						<h2 className="D_Name">{benefitName}</h2>{' '}
						<p className="D_Value">
							{res.results[element][benefitName]
								? res.results[element][benefitName]['description']
								: ''}
						</p>
					</div>
					{res.results[element][benefitName] &&
					parseInt(res.results[element][benefitName]['value']) > 0
						? 'R' +
						  parseFloat(res.results[element][benefitName]['value']).toFixed(2)
						: 'NA'}
					{res.results[element][benefitName] &&
					parseInt(res.results[element][benefitName]['value']) > 0 &&
					res.results[element][benefitName]['description'] ? (
						<Info
							style={{
								fontSize: '18px',
								position: 'relative',
								top: '4px',
								left: '5px',
								cursor: 'pointer',
								color: 'white',
								backgroundColor: 'black',
								borderRadius: '50%'
							}}
							onClick={e => {
								let benefitX = res.benefits.filter(
									b => b.name === benefitName
								)[0];
								var descriptiveName =
									benefitX.descriptiveName && benefitX.descriptiveName !== ''
										? benefitX.descriptiveName
										: benefitX.name;

								this.handleDialogOpen(
									e,
									res.results[element][benefitName]['description'],
									descriptiveName,
									element
								);
							}}
						/>
					) : (
						<div />
					)}
				</TableCell>
			);
		});

		return col;
	}

	makePolicyFee() {
		var col = [];
		var res = this.state.results;
		col.push(<TableCell key={'MakePolicyFeeHeading'}>Policy Fee</TableCell>);
		col.push(<TableCell key={'MakePolicyFee'} />);
		res.targets.forEach(element => {
			col.push(
				<TableCell className="centerCell" key={element}>
					{element === 'Liberty'
						? 'R15'
						: res.results[element]['Policy Fee']
						? res.results[element]['Momentum Interactive Fee']
							? 'R' +
							  (
									parseFloat(res.results[element]['Policy Fee']['value']) +
									parseFloat(
										res.results[element]['Momentum Interactive Fee']['value']
									)
							  ).toFixed(2)
							: 'R' +
							  parseFloat(res.results[element]['Policy Fee']['value']).toFixed(
									2
							  )
						: 'R0'}
				</TableCell>
			);
		});

		return col;
	}

	makeTotalPremium() {
		var col = [];
		var res = this.state.results;
		col.push(
			<TableCell key={'MakeTotalPremiumHeading'}>Total Premium</TableCell>
		);
		col.push(<TableCell key={'MakeTotalPremium'} />);
		res.targets.forEach(element => {
			col.push(
				<TableCell className="centerCell" key={element}>
					{res.results[element]['Premium'] &&
					parseInt(res.results[element]['Premium']['value']) > 0
						? 'R' +
						  parseFloat(res.results[element]['Premium']['value']).toFixed(2)
						: 'NA'}
				</TableCell>
			);
		});

		return col;
	}

	handlePopoverClose = () => {
		this.setState({ popoverOpen: false });
	};

	handlePopoverOpen = event => {
		this.setState({
			anchorTop: event.clientY,
			anchorLeft: event.clientX,
			popoverOpen: true
		});
	};

	makeDownloadLinks() {
		var res = this.state.results;
		var col = [];

		/////////////////////////////////////////////////
		//				client version code
		/*
		<Divider />
									<ListItem>
										<Typography
											variant="subheading"
											style={{
												marginLeft: '10px',
												marginRight: '10px'
											}}
										>
											Client Version
										</Typography>
									</ListItem>
									*/
		col.push(
			<TableCell key={res} style={{ paddingRight: '0px' }}>
				<ApolloConsumer>
					{client => (
						<div>
							{this.state.dog && <img src={this.state.dog.displayImage} />}
							<Button
								id="printButton"
								variant="outlined"
								className="outlinedButton"
								style={{
									color: '#55526f',
									borderRadius: '50px',
									marginTop: '10px',
									marginBottom: '10px'
								}}
								onClick={e =>
									!this.state.loadingPdf
										? this.handlePopoverOpen(e, 'downloadEl')
										: {}
								}
							>
								{this.state.loadingPdf ? (
									<CircularProgress color="secondary" size={20} />
								) : (
									'Print version'
								)}
							</Button>
							<Popover
								open={this.state.popoverOpen}
								onClose={() => this.handlePopoverClose()}
								anchorReference="anchorPosition"
								anchorPosition={{
									left: this.state.anchorLeft,
									top: this.state.anchorTop
								}}
							>
								<List component="nav">
									<ListItem
										button
										onClick={async () => {
											this.setState({ loadingPdf: true });
											const { data, errors } = await client.query({
												query: getResultPdf,
												variables: {
													path: this.state.guid,
													content: document
														.getElementById('resultTable')
														.innerHTML.toString()
														.replace(/"/g, "'")
												}
											});
											if (errors) {
												store.dispatch(
													showSnack({
														message: 'Error generating the PDF : ' + errors,
														color: 'danger'
													})
												);
											} else {
												this.onPdfGet(data);
											}
											this.setState({ loadingPdf: false });
											this.handlePopoverClose();
										}}
									>
										<Typography
											variant="subheading"
											style={{
												marginLeft: '10px',
												marginRight: '10px'
											}}
										>
											Print Version
										</Typography>
									</ListItem>

									
								</List>
							</Popover>
						</div>
					)}
				</ApolloConsumer>
			</TableCell>
		);

		col.push(
			<TableCell key={'makeDownloadLinksBlank'} style={{ padding: '0px' }}>
				{' '}
			</TableCell>
		);

		res.targets.forEach(element => {
			if (res.results[element].pdf_list) {
				var list = res.results[element].pdf_list.split(';');
				list.forEach((l, i) => {
					var leviosa = l;
					leviosa = leviosa.replace(ResultsPdfPhysicalPath, ResultsPdfUri);
					list[i] = leviosa;
				});

				col.push(
					<TableCell
						className="centerCell"
						key={element}
						style={{ padding: '0px' }}
					>
						<Button
							variant="outlined"
							className="outlinedButton"
							style={{
								color: '#55526f',
								borderRadius: '50px',
								marginTop: '10px',
								marginBottom: '10px'
							}}
							onClick={() => this.getMultiplePdfs(list)}
						>
							View PDFs
						</Button>
					</TableCell>
				);
			} else {
				var leviosa = res.results[element].pdf;
				leviosa = leviosa.replace(ResultsPdfPhysicalPath, ResultsPdfUri);

				col.push(
					<TableCell
						className="centerCell"
						key={element}
						style={{ padding: '0px' }}
					>
						<a href={leviosa} target="_blank">
							<Button
								variant="outlined"
								className="outlinedButton"
								style={{
									color: '#55526f',
									borderRadius: '50px',
									marginTop: '10px',
									marginBottom: '10px'
								}}
							>
								View PDF
							</Button>
						</a>
					</TableCell>
				);
			}
		});

		return col;
	}

	makePremiumPayable() {
		var col = [];
		var res = this.state.results;
		col.push(
			<TableCell key={'PremiumPayableHeading'}>Premium Payable</TableCell>
		);
		col.push(<TableCell key={'PremiumPayable'} />);

		res.targets.forEach(element => {
			col.push(
				<TableCell className="centerCell" key={element}>
					{res.results[element]['Premium'] &&
					parseInt(res.results[element]['Premium']['value']) > 0
						? res.results[element]['Discount']
							? 'R' +
							  parseFloat(
									parseFloat(res.results[element]['Premium']['value']) -
										parseFloat(res.results[element]['Discount']['value'])
							  ).toFixed(2)
							: 'R' +
							  parseFloat(res.results[element]['Premium']['value']).toFixed(2)
						: 'NA'}
				</TableCell>
			);
		});
		return col;
	}

	makeTableHeader() {
		var res = this.state.results;
		var row = [];
		var col = [];
		var temp = {};
		var i = 0;

		if (this.state.results) {
			col.push(
				<TableHead key={this.state.results}>
					<TableRow>
						<TableCell
							style=
							{{
								fontSize: '1.4em',
								fontWeight: '600',
							}}>Benefit </TableCell>
						<TableCell
							style=
							{{
								fontSize: '1.4em',
								fontWeight: '600',
							}} className="centerCell">Amount </TableCell>
						{this.targeter()}
					</TableRow>
				</TableHead>
			);
		}

		return col;
	}

	download(url) {
		document.getElementById('my_iframe').src = url;
	}
	makeTable() {
		var res = this.state.results;

		var row = [];
		var col = [];
		var temp = {};
		var i = 0;

		if (this.state.results) {
			col.push(this.fitter());

			var targetEmptyCells = [];
			var targets = this.state.results.targets;
			for (let t of targets) {
				targetEmptyCells.push(<TableCell key={t} />);
			}

			/*col.push(
				<TableRow key={Math.random()}>
					<TableCell />
					<TableCell />
					{targetEmptyCells}
				</TableRow>
			);*/

			col.push(<TableRow key={Math.random()}>{this.makePolicyFee()}</TableRow>);
			col.push(
				<TableRow 
					style=
					{{
						borderTop: 'double'
					}}
				key={Math.random()}>{this.makeTotalPremium()}
				</TableRow>
			);
			col.push(
				<TableRow key={Math.random()}>{this.makePremiumPayable()}</TableRow>
			);

			col.push(
				<TableRow 
				style=
				{{
					borderTop: 'double'
				}}
				key={Math.random()}>{this.makeDownloadLinks()}</TableRow>
			);
		}

		return col;
	}

	makeProductInfo() {
		let div = [];
		if (this.state.results) {
			this.state.results.benefits.forEach(benefit => {
				let benInfo = [];

				this.state.results.targets.forEach(target => {
					let res = this.state.results.results[target];

					let targetBen = res[benefit.name];

					if (targetBen) {
						benInfo.push(
							<div key={target}>
								<strong>{target}:</strong>
								<p style={{ whiteSpace: 'pre-line' }}>
									{targetBen.description}
								</p>
							</div>
						);
					}
				});

				var descriptiveName =
					benefit.descriptiveName && benefit.descriptiveName !== ''
						? benefit.descriptiveName
						: benefit.name;

				div.push(
					<div key={descriptiveName}>
						<h4>{descriptiveName} :</h4>
						{benInfo}
					</div>
				);
			});
		}

		return div;
	}

	onPdfGet = data => {
		var url = QuotePdfUri + this.state.guid + '.pdf';
		window.open(url, '_blank');
	};

	getMultiplePdfs = pdfs => {
		pdfs.forEach(p => {
			window.open(p, '_blank');
		});
	};

	handleDialogClose() {
		this.setState({ dialogOpen: false, popoverText: '' });
	}

	handleDialogOpen = (event, text, benefit, target) => {
		this.setState({
			anchorTop: event.clientY,
			anchorLeft: event.clientX,
			dialogOpen: true,
			popoverText: text,
			dialogTitle: target + ' - ' + benefit
		});
	};

	handleEdit(quote) {
		this.props.history.push({
			pathname: '/app/quote/',
			search: `clientId=${quote.fk_clientID}&guid=${this.state.guid}`
		});
	}

	render() {
		const params = ParseUriParams(this.props.location.search);
		const { guid } = params;

		return (
			<Query
				query={reqResult}
				variables={{
					guid: guid,
					token: GetUserToken()
				}}
				fetchPolicy="network-only"
			>
				{({ loading, error, data }) => {
					if (loading)
						return (
							<div>
								<LinearProgress />
							</div>
						);

					if (
						error &&
						error.message &&
						error.message === 'GraphQL error: invalid token'
					) {
						Logout();
						return <Redirect to="/app/portal/login" />;
					}

					if (error) return `Error! ${error.message}`;

					if (!this.state.resultsSet) {
						let results = JSON.parse(data.Results[0].token);

						let targetsArr = [...results.targets];
						targetsArr.sort();

						results.targets = targetsArr;

						const unsortedResults = { ...results.results };

						const sortedResults = Object.keys(unsortedResults)
							.sort()
							.reduce(
								(acc, key) => ({
									...acc,
									[key]: unsortedResults[key]
								}),
								{}
							);

						results.results = sortedResults;

						this.setState({
							results: results,
							resultsSet: true
						});
					}

					if (!this.state.results) {
						return (
							<div>
								<LinearProgress />
							</div>
						);
					}

					return (
						<div>
							<div id="resultTable">
								<Card>
									<CardContent>
										<Grid
											container
											justify="space-between"
											style={{ marginBottom: '15px' }}
										>
											<Grid item xs={12} sm={12} md={9} lg={9}>
												<Typography variant="headline">Results</Typography>
												{this.state.assistantActive ? (
													<Typography variant="caption" gutterBottom>
														{this.getBrokerName()}
													</Typography>
												) : null}
											</Grid>
											<Grid item xs={12} sm={12} md={1} lg={1}>
												<ApolloConsumer>
													{client => (
														<Button
															variant="outlined"
															className="outlinedButton"
															color="primary"
															onClick={async () => {
																const { data } = await client.query({
																	query: QuoteByGuid,
																	variables: {
																		guid: this.state.guid,
																		token: GetUserToken()
																	}
																});
																this.saveQuote(data.QuoteByGuid);
															}}
															id="editQuoteButton"
														>
															Save
														</Button>
													)}
												</ApolloConsumer>
											</Grid>

											<Grid item xs={12} sm={12} md={1} lg={1}>
												<ApolloConsumer>
													{client => (
														<Button
															variant="outlined"
															className="outlinedButton"
															color="primary"
															onClick={async () => {
																const { data } = await client.query({
																	query: QuoteByGuid,
																	variables: {
																		guid: this.state.guid,
																		token: GetUserToken()
																	}
																});
																this.handleEdit(data.QuoteByGuid);
															}}
															id="editQuoteButton"
														>
															Edit Quote
														</Button>
													)}
												</ApolloConsumer>
											</Grid>
										</Grid>
										<Paper style={{ overflowX: 'auto' }}>
											<Table className="resultsTable">
												{this.makeTableHeader()}
												<TableBody>{this.makeTable()}</TableBody>
											</Table>
											<Dialog
												open={this.state.dialogOpen}
												onClose={() => this.handleDialogClose()}
												aria-labelledby="form-dialog-title"
											>
												<DialogTitle id="form-dialog-title">
													<Typography variant="title" gutterBottom>
														{this.state.dialogTitle}
													</Typography>
												</DialogTitle>
												<DialogContent>
													<Typography
														variant="body1"
														gutterBottom
														style={{ whiteSpace: 'pre-line' }}
													>
														{this.state.popoverText}
													</Typography>
												</DialogContent>
												<DialogActions>
													<Button
														onClick={() => this.handleDialogClose()}
														color="primary"
													>
														Close
													</Button>
												</DialogActions>
											</Dialog>
										</Paper>
									</CardContent>
								</Card>
								<div id="productInfo" style={{ display: 'none' }}>
									{this.makeProductInfo()}
								</div>
								<div
									id="meta"
									style={{
										float: 'left',
										width: 'fit-content',
										padding: '24px'
									}}
								>
									<Typography>
										S/A = Standalone / Accelerator
										<br />
										T/NT = Tapering / Non-tapering
									</Typography>
								</div>
								<div
									style={{
										float: 'right',
										width: 'fit-content',
										padding: '24px'
									}}
								>
									<Typography variant="caption">
										NB : Please allow popups for this page.
									</Typography>
								</div>
							</div>
						</div>
					);
				}}
			</Query>
		);
	}
}

Results = graphql(SaveQuote)(Results);

export default Results;



// WEBPACK FOOTER //
// ./src/views/Quote/ResultsPage.jsx